// NPM Imports
import React, { useContext, useEffect, useState } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
import PayrollImpTypeModal, {
   usePayrollImpTypeModal,
} from '../../rows/misc/PayrollImpTypeModal'
// JS Imports
// Asset Imports

export default function PayrollImpTypeRow() {
   const state = useQuoteContext()
   const permissions = state.featurePermissions['PayrollImpTypeSelect']
   const permissionsFoundations =
      state.featurePermissions['PayrollImpFoundationsType']
   const permissionsNone = state.featurePermissions['PayrollImpNoneType']

   // If payroll imp is not in pricebook hide row
   if (state.product_list['payrollImp']?.NotInPricebook) {
      return <></>
   }
   const [isEINStateCountValid, setIsEINStateCountValid] = useState(false)

   // Checks every EIN State Count to see if any are above 3
   useEffect(() => {
      setIsEINStateCountValid(
         state.productPayrollStateCounts.every(
            (stateCount) => stateCount <= 10,
         ),
      )
   }, [state.productPayrollTotalStateCount])

   // Import the modal functionality
   const { handleSelfSetupType } = usePayrollImpTypeModal()

   if (
      permissions.includes(state.user_role) &&
      state.productPayrollEINCount <= 1 &&
      (state.productPayrollTotalEECount > 0 || state.isMultiEIN)
   ) {
      return (
         <>
            {/* Use the new modal component */}
            <PayrollImpTypeModal />

            <div className='row'>
               <div className='col-bhr1'>
                  {/*None*/}
                  {(permissionsNone.includes(state.user_role) ||
                     state.payrollImpType ===
                        state.payrollImpTypes[0].value) && (
                     <div className='form-check form-check-inline'>
                        <input
                           className='form-check-input'
                           type='radio'
                           name='inlineRadioOptions3'
                           id='payrollImp1Radio'
                           value={state.payrollImpTypes[0].value}
                           checked={
                              state.payrollImpType ===
                              state.payrollImpTypes[0].value
                           }
                           onChange={(e) =>
                              state.onPayrollImpOptionChange(
                                 e,
                                 e.target.value,
                                 0,
                              )
                           }
                        />
                        <label className='form-check-label'>
                           {state.payrollImpTypes[0].name}
                        </label>
                     </div>
                  )}

                  {/*Foundations*/}
                  {!state.product_list['payrollImpFoundations']
                     ?.NotInPricebook &&
                     ((permissionsFoundations.includes(state.user_role) &&
                        state.productPayrollTotalEECount < 51 &&
                        isEINStateCountValid) ||
                        state.payrollImpType ===
                           state.payrollImpTypes[1].value) && (
                        <div className='form-check form-check-inline'>
                           <input
                              className='form-check-input'
                              type='radio'
                              name='inlineRadioOptions3'
                              id='payrollImp2Radio'
                              value={state.payrollImpTypes[1].value}
                              checked={
                                 state.payrollImpType ===
                                 state.payrollImpTypes[1].value
                              }
                              onChange={handleSelfSetupType}
                           />
                           <label className='form-check-label'>
                              {state.payrollImpTypes[1].name}
                           </label>
                        </div>
                     )}

                  {/*Full*/}
                  {
                     <div className='form-check form-check-inline'>
                        <input
                           className='form-check-input'
                           type='radio'
                           name='inlineRadioOptions3'
                           id='payrollImp2Radio'
                           value={state.payrollImpTypes[2].value}
                           checked={
                              state.payrollImpType ===
                              state.payrollImpTypes[2].value
                           }
                           onChange={(e) =>
                              state.onPayrollImpOptionChange(
                                 e,
                                 e.target.value,
                                 0,
                              )
                           }
                        />
                        <label className='form-check-label'>
                           {state.payrollImpTypes[2].name}
                        </label>
                     </div>
                  }
               </div>
               <div className='col-bhr2'></div>
               <div className='col'></div>
               <div className='col'></div>
               <div className='col'></div>
               <div className='col'></div>
               {state.differenceQuote == true ? (
                  <>
                     <div className='col'></div>
                     <div className='col'></div>
                  </>
               ) : (
                  <></>
               )}
            </div>
         </>
      )
   }
}
